import * as z from "zod";
import { hsaReconciliationCsvOutputSchema } from "./hsa-reconciliation-common";

/** The payout detail table as a CSV, built by Redo: the table's columns in
 * order. Same access as `getHsaPayouts`. */
export const exportHsaPayoutCsv = {
  name: "exportHsaPayoutCsv" as const,
  input: z.object({ payoutId: z.string().min(1) }),
  output: hsaReconciliationCsvOutputSchema,
};
